import React from 'react';
import { Bike } from 'lucide-react';
import { ShoppingCart } from 'lucide-react';
import {
  MerchantCallClickEvent,
  ValetCallClickEvent,
} from '../../../../../../analytics/call-logging/events';
import { PackageCheck } from 'lucide-react';
import { PackageX } from 'lucide-react';
import { Blocks } from 'lucide-react';
import { Ban } from 'lucide-react';
import { Clock9 } from 'lucide-react';
import { CircleCheckBig } from 'lucide-react';

const MAX_SSE_RETRIES = 5;
const RETRY_SSE_INTERVAL_MS = 3000;

const CallEntity = {
  SM: {
    header: 'Call SM',
    icon: <ShoppingCart size={18} />,
  },
  DP: {
    header: 'Call DP',

    icon: <Bike size={22} strokeWidth={1.7} />,
  },
};

const CalledTo = {
  SM: 'Merchant',
  DP: 'Rider',
};

const JumboEventFunction = {
  SM: MerchantCallClickEvent,
  DP: ValetCallClickEvent,
};

const DropdownOptionIcon = {
  ALL_ITEMS_PACKED: PackageCheck,
  ALL_ITEMS_NOT_PACKED: PackageX,
  SOME_ITEMS_NOT_PACKED: Blocks,
  UNRESPONSIVE: Ban,
  ALL_ITEMS_DELIVERED: PackageCheck,
  ALL_ITEMS_NOT_DELIVERED: PackageX,
  SOME_ITEMS_NOT_DELIVERED: Blocks,
};

const ResolutionStatusIcon = {
  'waiting...': {
    icon: <Clock9 size={18} />,
    styles: 'tw-bg-teal-100 tw-border-teal-200/50',
  },
  'resolution ready': {
    icon: <CircleCheckBig size={19} className='tw-text-base-green' />,
    styles: 'tw-bg-green-200/10 tw-border-base-green/50',
  },
  'service denied': {
    icon: <Ban size={18} className='tw-text-red-500' />,
    styles: 'tw-bg-red-200/20 tw-border-red-600/50',
  },
};

export {
  CallEntity,
  CalledTo,
  JumboEventFunction,
  DropdownOptionIcon,
  ResolutionStatusIcon,
  MAX_SSE_RETRIES,
  RETRY_SSE_INTERVAL_MS,
};
